import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {mtestRequestTypeIds, mtestTypeCases} from '@shared/constants/mtest.constants';

@Component({
  selector: 'si-mtest-medical-test-icon',
  templateUrl: './mtest-medical-test-icon.component.html',
  styleUrls: ['./mtest-medical-test-icon.component.scss']
})
export class MtestMedicalTestIconComponent implements OnInit {
  @Input() requestId: number;
  @Input() appointmentDate: number;
  @Input() canSchedule: boolean;
  @Input() requestTypeId: number;
  @Input() showOnlyIcon: boolean;
  mtestRequestTypeIds = mtestRequestTypeIds;
  mtestTypeCases = mtestTypeCases;
  requestedText: string;
  case: number;

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
    if (this.appointmentDate) {
      this.case = mtestTypeCases.SCHEDULED;
      this.requestedText = (this.requestTypeId === mtestRequestTypeIds.TREATMENT_REQUEST ? 'SI_END_TREATMENT_DATE_AT_TIME'.toString() : 'SI_APPOINTMENT_DATE_AT_TIME'.toString());
    } else if (this.canSchedule) {
      this.case = mtestTypeCases.CAN_SCHEDULE;
      this.requestedText = 'SI_APPOINTMENT_REQUEST'.toString();
    } else {
      this.case = mtestTypeCases.CANT_SCHEDULE;
      this.requestedText = 'SI_APPOINTMENT_ONLY_AT_HEALTH_CENTER'.toString();
    }
  }

  onClickRequestAppointment(): void {
    if (this.case !== mtestTypeCases.CAN_SCHEDULE) {
      return;
    }

    this.router.navigate(
      ['appointment', 'request'],
      {
        queryParams: {requestId: this.requestId},
        queryParamsHandling: 'merge',
      }
    );
  }
}
